<template>
    <div class="standings-page">
        <page-hero title="Βαθμολογία" eyebrow="Standings" compact />
        <div class="cl-page">
            <v-container fluid class="my-0 py-0">
                <filters :cup="true" @getRankingByLeague="getRankingByLeague" @getRankingByTeam="getRankingByTeam" @getCupState="getCupState" @clear="clearData" />
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            v-if="type === 'regular_season'"
                            :headers="headers"
                            :items="ranking"
                            class="elevation-1  py-3 px-3 text-center"
                            hide-default-footer
                            disable-sort
                            :mobile-breakpoint="0"
                            :items-per-page="-1"
                            dark
                            style="background-color: #232323; cursor: pointer;"
                        >
                            <template v-slot:item.club="{ item }">
                                <v-row align="center" justify="center">
                                    <v-col cols="3">
                                        <v-avatar style="border-radius: 10px;" size="50" color="white">
                                            <v-img
                                                v-if="item.imageUrl"
                                                :src="`${assetsUrl}/${item.imageUrl}`"
                                            />
                                            <v-icon v-else :style="$vuetify.breakpoint.mobile ? '' : 'font-size: 40px'" class="teal--text"> mdi-basketball-hoop </v-icon>
                                        </v-avatar>
                                    </v-col>
                                    <v-col cols="9">
                                        <span class="font-weight-bold">{{ item.name }}</span>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.gp="{ item }">
                                <v-row align="center">
                                    <v-col cols="12">
                                        {{ (item.won + item.lost) }}
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.win_percentage="{ item }">
                                <v-row align="center">
                                    <v-col cols="12">
                                        {{ `${(item.won + item.lost) > 0 ? (item.won / (item.won + item.lost) * 100).toFixed(1) : 0}%` }}
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-slot:item.position="{ item }">
                                <v-row align="center">
                                    <v-col cols="12">
                                        {{ ranking.indexOf(item) + 1 }}
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                        <!-- the bracket made in the CMS; the playoffs of a league without one: the picture of its standings -->
                        <bracket-board v-else-if="bracketLoaded" :bracket="bracket" @match="openMatch" />
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import Filters from '@/components/GenericFilters'
    import BracketBoard from '@/components/BracketBoard'
    import bracketService from '@/services/bracket'
    import teamService from '@/services/team'
    import leagueService from '@/services/league.js'

    export default {
        components: { PageHero, Filters, BracketBoard },
        data() {
            return {
                headers: [
                    { text: 'Club', value: 'club', width: '200px', align: 'start' },
                    { text: 'Points', value: 'standing', width: '50px', align: 'center' },
                    { text: 'GP', value: 'gp', width: '50px', align: 'center' },
                    { text: 'Won', value: 'won', width: '50px', align: 'center' },
                    { text: 'Lost', value: 'lost', width: '50px', align: 'center' },
                    { text: 'Win(%)', value: 'win_percentage', width: '50px', align: 'center' },
                    { text: 'Pts+', value: 'pointsPlus', width: '50px', align: 'center' },
                    { text: 'Pts-', value: 'pointsMinus', width: '50px', align: 'center' },
                    { text: '+/-', value: 'pointsDiff', width: '50px', align: 'center' }
                ],
                ranking: [],
                assetsUrl: 'https://storage.googleapis.com',
                type: 'regular_season',
                bracket: null,
                bracketLoaded: false,
                bracketRequest: null,
                // the ranking of the latest choice only
                rankingRequest: 0
            }
        },
        created() {
        },
        methods: {
            // another season: nothing on screen until its data comes
            clearData() {
                this.rankingRequest++
                this.bracketRequest = null
                this.ranking = []
                this.bracket = null
                this.bracketLoaded = false
            },
            getCupState(isCup, leagueId, seasonId) {
                this.type = isCup ? 'cup' : 'playoffs'
                this.bracket = null
                this.bracketLoaded = false
                // the filters send no season with the cup: the active one
                const request = { seasonId: seasonId || this.$store.getters.getConfig?.activeSeasonId, leagueId, cup: isCup }
                const requestKey = JSON.stringify(request)
                this.bracketRequest = requestKey
                bracketService.getBracket(request).then(resp => {
                    // only the answer of the latest choice
                    if (this.bracketRequest === requestKey) {
                        this.bracket = resp.data || null
                    }
                }).catch(() => {}).finally(() => {
                    if (this.bracketRequest === requestKey) {
                        this.bracketLoaded = true
                    }
                })
            },
            openMatch(matchId) {
                this.$router.push(`/Match/${matchId}`)
            },
            getRankingByTeam(teamId, type) {
                this.type = type || 'regular_season'
                const request = ++this.rankingRequest
                teamService.getRankingByTeam(teamId, type).then(resp => {
                    if (request !== this.rankingRequest) return
                    this.ranking = resp.data
                    // this.ranking.sort(this.compare)
                })
            },
            getRankingByLeague(leagueId, seasonId, type) {
                this.type = type || 'regular_season'
                const request = ++this.rankingRequest
                leagueService.getRankingByLeague(leagueId, seasonId, type).then(resp => {
                    if (request !== this.rankingRequest) return
                    this.ranking = resp.data
                    // this.ranking.sort(this.compare)
                })
            },
            compare(a, b) {
                if (a.standing < b.standing) {
                    return 1
                }
                if (a.standing > b.standing) {
                    return -1
                }
                if (a.standing === b.standing) {
                    return b.pointsDiff >= a.pointsDiff ? 1 : -1
                }
                return 0
            }
        }
    }
</script>

<style scoped>

.bg {
    position: absolute;

    /* background: url('../assets/basketball-bg-1.jpg'); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
}
</style>
